import { useStore } from "src/store/store";
import AuthScreen from "./AuthScreen";
import UnAuthScreen from "./UnAuthScreen";

const HomePage = () => {
	const store = useStore();

	if (store.user) {
		return <AuthScreen />;
	}

	return <UnAuthScreen />;
};

export default HomePage;
